export const MENU_OPEN = "MENU_OPEN";
export const MENU_CLOSED = "MENU_CLOSED";
export const NEW_USER = "NEW_USER";
export const OLD_USER = "OLD_USER";
export const CHANGE_PAGE = "CHANGE_PAGE";
export const SAVE_FILTERS = "SAVE_FILTERS";



// WEBPACK FOOTER //
// ./src/utils/actionTypes.js